
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cities/[...cities]",
      function () {
        return require("private-next-pages/cities/[...cities].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cities/[...cities]"])
      });
    }
  